import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

/** Keep the sector profile behind the plan skin entitlement. */
@Injectable({ providedIn: 'root' })
export class ProfileFinancialServicesGuard {
  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const fullProfile = () => this.router.createUrlTree(['/profile', route.paramMap.get('id')], {
      queryParams: route.queryParams,
      fragment: route.fragment,
    });

    return this.authenticationService.getPlanFeaturesEnabled().pipe(
      map(plan => Array.isArray(plan?.available_dashboard_skins) &&
        plan.available_dashboard_skins.includes('financial_services') ? true : fullProfile()),
      catchError(() => of(fullProfile()))
    );
  }
}
